export enum PolicySaveRestriction {
  NONE = 0,
  DEFAULT_POLICY,
  OTHER_USER,
  OTHER_COMPANY,
  NO_WRITE_RIGHTS,
}

export interface SaveButtonSlice {
  restriction: PolicySaveRestriction;
  isLoading: boolean;
  isSaving: boolean;
  isWaitingValidation: boolean;
}
